import React from 'react';
import Home from './Home';
import Portfolio from './Portfolio';
import Project from "./Project";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
    return (
        <Router>
            <div className="main-wrapper">

                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
                <Routes>
                    <Route path="/portfolio" element={<Portfolio />} />
                </Routes>
                <Routes>
                    <Route path="/project" element={<Project />} />
                </Routes>

            </div>
        </Router>
    );
}

export default App;